import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Body20 } from 'components/Typography'
import { useTheme } from 'styled-components'
import {
  ProductCardColumn,
  ProductCardContainer,
  ProductCardHeading,
} from './ProductCardInfo.style'
import ProductCardPriceInfo from '../ProductCardPriceInfo'

const ProductCardInfo = ({
  brand,
  productBrandNameOverride,
  currency,
  description,
  rrpPrice,
  salePrice,
  villagePrice,
  labels,
  isColoredBg,
}) => {
  const labelsContainerRef = useRef(null)

  const [enablePriceLabelMinWidth, setEnablePriceLabelMinWidth] = useState(
    false
  )

  const {
    colors: { sagedarkToblack, whiteToSandstone },
    textStyles: { fontPrimary },
  } = useTheme()

  useEffect(() => {
    if (labelsContainerRef?.current?.offsetWidth >= 290) {
      setEnablePriceLabelMinWidth(true)
    } else {
      setEnablePriceLabelMinWidth(false)
    }
  }, [])

  const infoColor = isColoredBg ? whiteToSandstone : sagedarkToblack

  return (
    <ProductCardContainer ref={labelsContainerRef}>
      <ProductCardColumn>
        <Body20 color={infoColor} style={{ fontFamily: fontPrimary }}>
          {productBrandNameOverride || brand}
        </Body20>
        <ProductCardHeading color={infoColor}>{description}</ProductCardHeading>
      </ProductCardColumn>
      <ProductCardColumn>
        <ProductCardPriceInfo
          {...{
            currency,
            rrpPrice,
            salePrice,
            villagePrice,
            labels,
            enablePriceLabelMinWidth,
            isColoredBg,
          }}
        />
      </ProductCardColumn>
    </ProductCardContainer>
  )
}

ProductCardInfo.propTypes = {
  brand: PropTypes.string.isRequired,
  productBrandNameOverride: PropTypes.string,
  currency: PropTypes.string,
  description: PropTypes.string.isRequired,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  labels: PropTypes.shape({}),
  isColoredBg: PropTypes.bool,
}

ProductCardInfo.defaultProps = {
  productBrandNameOverride: '',
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  labels: {},
  isColoredBg: false,
}

export default ProductCardInfo
